import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';
import { Baby, Heart, Clock } from 'lucide-react';

const FemmeEnceinte = () => {
  const navigate = useNavigate();

  const handleReserve = (serviceName) => {
    navigate(`/reservation?service=${encodeURIComponent(serviceName)}`);
  };

  return (
    <div className="page-service">
      {/* Hero Header */}
      <section className="service-hero">
        <div className="service-hero-pattern" />
        <div className="service-hero-content">
          <h1 className="service-hero-title">Gamme Femme Enceinte</h1>
          <h2 className="service-hero-subtitle-large">& Jeune Maman</h2>
          <Baby className="hero-icon" size={48} strokeWidth={1.5} />
          <p className="service-hero-description">
            Massages adaptés pour accompagner cette période unique de votre vie 
            avec douceur et bienveillance
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="service-list-section">
        <div className="container-service">
          {services.femmeEnceinte.map((service, index) => (
            <div key={service.id} className="service-item">
              <div className="service-item-content">
                <div className="service-item-header">
                  <Heart className="service-icon" size={24} />
                  <div>
                    <h2 className="service-item-title">{service.name}</h2>
                    <div className="service-item-duration">
                      <Clock size={16} />
                      <span>{service.duration}</span>
                    </div>
                  </div>
                </div>
                
                <p className="service-item-description">{service.description}</p>
                
                <div className="service-item-footer">
                  <div className="service-price-info">
                    <span className="service-price-label">Tarif première visite :</span>
                    <span className="service-price-first">{service.firstVisitPrice}€</span>
                  </div>
                  <button
                    onClick={() => handleReserve(service.name)}
                    className="btn-reserve-service"
                  >
                    Réserver
                  </button>
                </div>
              </div>
              
              <div className="service-item-price">
                <div className="price-badge">
                  <span className="price-amount">{service.price}€</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Info Section */}
      <section className="info-section">
        <div className="container-service">
          <div className="info-card pregnancy-info">
            <Baby size={48} strokeWidth={1.5} className="info-main-icon" />
            <h3 className="info-title">Soins Adaptés & Sécurisés</h3>
            <p className="info-text">
              Nos massages sont spécialement conçus pour les femmes enceintes et jeunes mamans. 
              Ils respectent votre corps et ses transformations, pour vous offrir un moment 
              de détente en toute sérénité.
            </p>
            <div className="info-features">
              <div className="info-feature">
                <span className="info-icon">🤰</span>
                <span>Positions adaptées</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">💆‍♀️</span>
                <span>Techniques douces</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">🌿</span>
                <span>Huiles sûres</span>
              </div>
              <div className="info-feature">
                <span className="info-icon">👶</span>
                <span>Bébé bienvenu</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="service-cta-content">
          <h3 className="service-cta-title">Offrez-vous un moment de douceur</h3>
          <p className="service-cta-text">
            Prenez soin de vous pendant cette période si spéciale
          </p>
          <Link to="/reservation" className="btn-primary">
            Réserver maintenant
          </Link>
        </div>
      </section>
    </div>
  );
};

export default FemmeEnceinte;
